module.exports = __webpack_public_path__ + "static/media/2017_conf_Implants_and_Body_Hacking.c362e560.png";